import React from "react";
import { Redirect } from "react-router-dom";
import Login from "pages/Provider/Authentication/Login";
import ForgetPassword from "pages/Provider/Authentication/ForgetPassword";
import Resetpassword from "pages/Provider/Authentication/Resetpassword";
import Logout from "pages/Provider/Authentication/Logout";
import Dashboard from "pages/Provider/Dashboard/index";
import Pages404 from "pages/Utility/pages-404";
import Pages500 from "pages/Utility/pages-500";
import { providerPrefix } from "configs/routePrefix";
import LeadsPage from "pages/Provider/Leads"
import DealsPage from "pages/Provider/Deals"
import AppoinmentsPage from "pages/Provider/Appoinments"
import AddLeadPage from "pages/Provider/Leads/AddLead"
import AddDealPage from "pages/Provider/Deals/AddDeal"
import EditDealPage from "pages/Provider/Deals/EditDeal"
import SellerPage from "pages/Provider/Seller"

import AddAppoinmentPage from "pages/Provider/Appoinments/AddAppoinment"
import ViewAppoinmentsPage from "pages/Provider/Appoinments/ViewAppoinment"

import AddActivityPage from "pages/Provider/Leads/AddActivity"
import AddActivityPageDeal from "pages/Provider/Deals/AddActivity"

import ViewLeadPage from "pages/Provider/Leads/ViewLead"
import ViewDealPage from "pages/Provider/Deals/ViewDeal"
import ProviderDashBoard from "pages/Provider/Dashboard"
import Profile from "pages/Provider/Profile"
import Activities from "pages/Provider/Dashboard/Activities";
import ResalePage from "pages/Provider/Resale";
import CreateResale from "pages/Provider/Resale/CreateResale";
import ViewResale from "pages/Provider/Resale/View"
import DeveloperPage from "pages/Provider/Developer";
import CompoundList from "pages/Provider/Compound";
import Cards from "pages/Provider/Compound/Cards";
import PaymentPlan from "pages/Provider/PaymentPlan";
import BuildingList from "pages/Provider/Building";
import PropertyList from "pages/Provider/Property";
import CompoundDetails from "pages/Provider/Compound/Details";

const salesRepRoutes = [

  { path: "/dashboard", component: ProviderDashBoard },
  { path: "/activities", component: Activities },
  { path: "/Profile", component: Profile },

  { path: "/Admin-developer", component: DeveloperPage },
  { path: "/Admin-developer/compound-list/:id", component: CompoundList },
  { path: "/Admin-developer/compound/:id", component: CompoundDetails },
  { path: "/Admin-developer/cards/:id", component: Cards },
  { path: "/Admin-developer/payment-plan/:id", component: PaymentPlan },
  { path: "/Admin-developer/building", component: BuildingList },
  { path: "/Admin-developer/property", component: PropertyList },

  { path: "/leads", component: LeadsPage },
  { path: "/leads/add-lead", component: AddLeadPage },
  { path: "/leads/view-lead/:id", component: ViewLeadPage },

  { path: "/resale", component: ResalePage },
  { path: "/resale/create-resale", component: CreateResale },
  { path: "/resale/view-resale/:id?", component: ViewResale },
  { path: "/resale/edit-resale/:id?", component: CreateResale },

  { path: "/deals", component: DealsPage },
  { path: "/deals/view-deal/:id", component: ViewDealPage },
  { path: "/deals/add-deal/:id?", component: AddDealPage },
  { path: "/deals/add-activity/:id/:type", component: AddActivityPage },
  { path: "/deals/deal-activity/:id/:leadId", component: AddActivityPageDeal },
  { path: "/deals/Edit-deal/:id", component: EditDealPage },

  { path: "/appoinments", component: AppoinmentsPage },
  { path: "/appoinments/view-appoinment/:id", component: ViewAppoinmentsPage },
  { path: "/appoinments/book-appoinment/:id?/:leadId?", component: AddAppoinmentPage },
  { path: "/appoinments/edit-appoinment/:id?", component: AddAppoinmentPage },


  { path: "/seller", component: SellerPage },
  
  { path: `/logout`, component: Logout },
  { path: `/dashboard`, component: Dashboard },
  { path: `/pages-404`, component: Pages404 },
  // this route should be at the end of all other routes
  {
    path: `/`,
    exact: true,
    component: () => <Redirect to={`${providerPrefix}/dashboard`} />,
  },
  {
    path: `*`,
    component: () => <Redirect to={`${providerPrefix}/pages-404`} />,
  },
];

const salesRepAuthRoutes = [
  { path: `/login`, component: Login },
  { path: `/forget-password`, component: ForgetPassword },
  { path: `/reset-password`, component: Resetpassword },
  { path: `/pages-500`, component: Pages500 },
];

export { salesRepRoutes, salesRepAuthRoutes };
